import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=3cf6abfe&scoped=true&"
import script from "./FAQs.vue?vue&type=script&lang=js&"
export * from "./FAQs.vue?vue&type=script&lang=js&"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=3cf6abfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6abfe",
  null
  
)

export default component.exports